import Model from './model.js';
import Log from 'lib/log';
import queryString from 'query-string';
import axios from 'axios';
import config from 'config';
const log = Log('newModels/report');

const ENDPOINT_URL = config.apiUrl + '/Reports';

export default class Report extends Model {
    constructor() { super(); throw new Error(`Reports are not instantiable`); }
    save() { log.warn(`Reports cannot be saved`); }
    fetch() { log.warn(`Reports cannot be fetched`); }
    set() { log.warn(`Reports don't have attributes`); }
    validate() { log.warn(`Reports are not validatable`); }

    static totals({
        companyId, employees, locations, fromDate, toDate
    }) {
        return axios.get(`${ENDPOINT_URL}/totals`, {
            params: {
                companyId,
                employees,
                locations,
                fromDate,
                toDate
            },
            headers: {'Authorization': app.user.getAccessToken().id},
            responseType: 'json'
        }).then(r => r.data);
    }

    static downloadUrl({
        companyId, employees, locations, fromDate, toDate
    }) {
        return `${ENDPOINT_URL}/download?${queryString.stringify({
            companyId,
            employees: employees || [],
            locations: locations || [],
            fromDate,
            toDate,
            'access_token': app.user.getAccessToken().id
        })}`;
    }

    static sendLeaveReport({
        companyId, date, isEndAtDate
    }) {
        return axios.post(
            `${ENDPOINT_URL}/sendLeaveReport`,
            {companyId, date, isEndAtDate},
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(r => r.data);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/report.js